import apolloClient from '@src/graphql/apollo';
import {
  RecordSignalInput,
  RecordSignalsDocument,
  RecordSignalsMutation,
  RecordSignalsMutationVariables,
} from '../generated';
import { RecordSignalsParams } from './interfaces/recordSignals.interface';

export const recordSignals = async ({ items, signalType, currentLimit }: RecordSignalsParams): Promise<void> => {
  try {
    const batch = currentLimit ? items.slice(-Math.abs(currentLimit)) : items;

    const signals: RecordSignalInput[] = batch.map(({ type, id }) => ({
      entityId: id,
      entityType: type,
      type: signalType,
    }));

    await apolloClient.mutate<RecordSignalsMutation, RecordSignalsMutationVariables>({
      mutation: RecordSignalsDocument,
      variables: { signals },
    });
  } catch (_) {}
};
